export function getPlainTextFromFormatted(text: string) {
  // remove html tags <b> <i> <u>
  return text
    .replace(/<\/?[BIUbiu]\/?>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
}
